import { app as appInitialState } from "../model/initialState";
export const BASE = "i/v2/kcc/";
export const MEDIUM = "api/v1/";
export const USERS = "i/v1/users";
export const POINT = "i/v1";
export const KCC = "i/v1/kcc";
export const ENDPOINT = `${appInitialState.ENDPOINT}`;

export const GET_CONFIG = {
  method: "GET",
  mode: "cors",
  headers: { Accept: "application/json" },
};
export const PUT_CONFIG = {
  method: "PUT",
  mode: "cors",
  headers: { "Content-Type": "application/json" },
};
export const POST_CONFIG = {
  method: "POST",
  mode: "cors",
  headers: { "Content-Type": "application/json" },
};

export const PATHS = {
  authorization: `${KCC}/authenticate`,
  registration: `${BASE}users/create`,
  enrolDependent: `${BASE}dependents/addAndEnroll`,
  inviteDependent: `${KCC}/dependents/add`,
  boldEnroll: `${KCC}/dependents/enroll`,
};
